/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import React, { useState } from "react";
import { PlusCircle, Search } from "@jda/lui-common-icon-library-mui5";
import { IconButton, Tooltip, Box, TextField, InputAdornment } from "@mui/material";

import useStyles from "./styles";

interface ISearchBar {
  onSearchTextBoxChange: any;
  placeHolder: string;
  addButtonMessage: String;
  addButtonDialog: Function;
  onClearTextInput?: Function;
  showAddButton?: boolean;
};

const SearchBar = (props: ISearchBar) => {
  const classes = useStyles();
  const { onSearchTextBoxChange, onClearTextInput } = props;

  const [inputText, setInputText] = useState("");

  const onChangeText = (event: React.ChangeEvent<HTMLInputElement>) => {
    setInputText(event.currentTarget.value);
    onSearchTextBoxChange(event.currentTarget.value);
    if (event.currentTarget.value === "") {
      onClearTextInput && onClearTextInput();
    }
  };

  return (
    <Box className={classes.searchBox}>
      <TextField
        value={inputText}
        onChange={onChangeText}
        placeholder={props.placeHolder}
        className={classes.searchTextBox}
        variant="standard"
        inputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Search />
            </InputAdornment>
          ),
        }}
      />
      <Box>
        {props.showAddButton && (
          <Tooltip title={props.addButtonMessage}>
            <IconButton
              aria-label="create"
              id="createBtn"
              onClick={() => {
                props.addButtonDialog("Add");
              }}
            >
              <PlusCircle data-testid="customers-plus-icon" />
            </IconButton>
          </Tooltip>
        )}
      </Box>
    </Box>
  );
};

export default SearchBar;
